/* eslint-disable*/
import React, { useEffect, useState, useRef, useCallback } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
  faChevronLeft,
  faChevronRight,
  faDownload,
  faSearch,
  faHome,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { API_URL } from "../../config";
import LoadingSpinner from "../../components/LoadingSpinner.jsx";
import Select from "react-select";
import moment from "moment";
import { showToast } from "../../components/toast";
import { addMonths, subMonths, startOfMonth } from "date-fns";
import '../../components/skeletonRow.css'
import { click } from "@testing-library/user-event/dist/cjs/convenience/click.js";

const parseAmountRange = (value) => {
  if (!value || typeof value !== "string") return { min: undefined, max: undefined };
  const trimmed = value.trim();
  if (!trimmed) return { min: undefined, max: undefined };

  const rangeMatch = trimmed.match(/^(\d+(?:\.\d+)?)\s*(?:-|to)\s*(\d+(?:\.\d+)?)$/i);
  if (rangeMatch) return { min: rangeMatch[1], max: rangeMatch[2] };

  const minMatch = trimmed.match(/^(?:>=?|>)\s*(\d+(?:\.\d+)?)$/) || trimmed.match(/^(\d+(?:\.\d+)?)\+$/);
  if (minMatch) return { min: minMatch[1], max: undefined };

  const maxMatch = trimmed.match(/^(?:<=?|<)\s*(\d+(?:\.\d+)?)$/);
  if (maxMatch) return { min: undefined, max: maxMatch[1] };

  const exactMatch = trimmed.match(/^(\d+(?:\.\d+)?)$/);
  if (exactMatch) return { min: exactMatch[1], max: exactMatch[1] };

  return { min: undefined, max: undefined };
};

const SubscriberAnalysisReport = () => {
  const [subscriberData, setSubscriberData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [isRendering, setIsRendering] = useState(false);
  const tableRenderedRef = useRef(false);
  const prevMonthStart = startOfMonth(subMonths(new Date(), 1));

  // Refs for double scroll - MOVED TO TOP
  const tableContainerRef = useRef(null);
  const topScrollbarRef = useRef(null);
  const topScrollbarContentRef = useRef(null);

  // Separate state for form inputs and actual filters
  const [formInputs, setFormInputs] = useState({
    recent_contacted_start: null,
    recent_contacted_end: null,
    created_on_start: null,
    created_on_end: null,
    lead_source: "",
    inv_capital: "",
    lead_status: "",
    next_followup_start: null,
    next_followup_end: null,
    subscriberid: "",
    language: "",
    state: "",
    client_status: "",
    subscribed_on_start: null,
    subscribed_on_end: null,
    subscriber_status: "",
    updated_on_start: null,
    updated_on_end: null,
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_content: "",
    utm_term: "",
    adset_name: "",
    exp_in_market: "",
    investments: "",
    convertible: "",
    clickid: "",
    clicktype: "",
    first_amount: "",
  });

  const [filters, setFilters] = useState({
    recent_contacted_start: "",
    recent_contacted_end: "",
    created_on_start: "",
    created_on_end: "",
    lead_source: "",
    inv_capital: "",
    lead_status: "",
    next_followup_start: "",
    next_followup_end: "",
    subscriberid: "",
    language: "",
    state: "",
    client_status: "",
    subscribed_on_start: "",
    subscribed_on_end: "",
    subscriber_status: "",
    updated_on_start: "",
    updated_on_end: "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_content: "",
    utm_term: "",
    adset_name: "",
    exp_in_market: "",
    investments: "",
    convertible: "",
    clickid: "",
    clicktype: "",
    first_amount: "",
    orderbycol: "created_on",
    orderby: "desc",
    page: 1,
    limit: 100,
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    showingRecords: "Showing 0 to 0 of 0 entries",
  });

  const [dropdownOptions, setDropdownOptions] = useState({
    leadSourceList: [],
    invCapitalList: [],
    leadStatusList: [],
    languageList: [],
    stateList: [],
    clientStatusList: [],
    subscriberStatusList: [],
    utmSourceList: [],
    utmMediumList: [],
    utmCampaignList: [],
    utmContentList: [],
    utmTermList: [],
    adsetNameList: [],
    expInMarketList: [],
    investmentsList: [],
    convertibleList: [],
    clickTypeList: [],
  });

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "30px",
      height: "30px",
      fontSize: "12px",
      borderRadius: "0",
      border: "1px solid #ced4da",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #ced4da",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "30px",
      padding: "0 6px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "12px",
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "4px 10px",
    }),
    // Add this to remove the clear (X) button
    clearIndicator: () => ({
      display: "none",
    }),
  };

  const handleReactSelectChange = (selectedOption, { name }) => {
    const value = selectedOption ? selectedOption.value : "";

    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFilters((prev) => ({
      ...prev,
      [name]: value,
      page: 1,
    }));
  };

  // Transform API response to dropdown format
  const transformDropdownData = (apiData) => {
    const leadSourceList = (apiData.lead_sourcelist || []).map((source) => ({
      value: source.pick_name,
      label: source.pick_name,
    }));

    const invCapitalList = (apiData.inv_caplist || []).map((capital) => ({
      value: capital.pick_name,
      label: capital.pick_name,
    }));

    const leadStatusList = (apiData.lead_statuslist || []).map((status) => ({
      value: status.pick_name,
      label: status.pick_name,
    }));

    const languageList = (apiData.languagelist || []).map((lang) => ({
      value: lang.id,
      label: lang.name,
    }));

    const stateList = (apiData.statelist || []).map((state) => ({
      value: state.state_name,
      label: state.state_name,
    }));

    const clientStatusList = (apiData.client_statuslist || []).map(
      (status) => ({
        value: status.pick_name,
        label: status.pick_name,
      })
    );

    const subscriberStatusList = (apiData.subscriber_statuslist || []).map(
      (status) => ({
        value: status,
        label: status,
      })
    );

    const utmSourceList = (apiData.utmsourcelist || []).map((source) => ({
      value: source.utm_source,
      label: source.utm_source,
    }));

    const utmMediumList = (apiData.utmmediumlist || []).map((medium) => ({
      value: medium.utm_medium,
      label: medium.utm_medium,
    }));

    const utmCampaignList = (apiData.utmcampaignlist || []).map((campaign) => ({
      value: campaign.utm_campaign,
      label: campaign.utm_campaign,
    }));

    const utmContentList = (apiData.utmcontentlist || []).map((content) => ({
      value: content.utm_content,
      label: content.utm_content,
    }));

    const utmTermList = (apiData.utmtermlist || []).map((term) => ({
      value: term.utm_term,
      label: term.utm_term,
    }));

    const adsetNameList = (apiData.adsetnamelist || []).map((adset) => ({
      value: adset.adset_name,
      label: adset.adset_name,
    }));

    // New dropdown lists for the three fields
    const expInMarketList = (apiData.ExpInMarkets || []).map((item) => ({
      value: item.pick_name,
      label: item.pick_name,
    }));

    const investmentsList = (apiData.Investments || []).map((item) => ({
      value: item.pick_name,
      label: item.pick_name,
    }));

    const convertibleList = (apiData.Convertible || []).map((item) => ({
      value: item.pick_name,
      label: item.pick_name,
    }));

    const clickTypeList = (apiData.clicktypelist || []).map((item) => ({
      value: item.name,
      label: item.name,
    }));

    return {
      leadSourceList,
      invCapitalList,
      leadStatusList,
      languageList,
      stateList,
      clientStatusList,
      subscriberStatusList,
      utmSourceList,
      utmMediumList,
      utmCampaignList,
      utmContentList,
      utmTermList,
      adsetNameList,
      expInMarketList,
      investmentsList,
      convertibleList,
      clickTypeList,
    };
  };

  // Helper to build unified filter payload for fetch & export
  const buildFilterPayload = (activeFilters, currentInputs = {}, isExport = false) => {
    const merged = {
      ...activeFilters,
      ...currentInputs,
    };

    const filterParams = {};

    if (!isExport) {
      filterParams.page = (activeFilters.page || 1) - 1;
      filterParams.limit = activeFilters.limit || 100;
    }
    filterParams.orderbycol = activeFilters.orderbycol || "created_on";
    filterParams.orderby = (activeFilters.orderby || "desc").toUpperCase();

    const fields = [
      "lead_source",
      "inv_capital",
      "lead_status",
      "subscriberid",
      "language",
      "state",
      "client_status",
      "subscriber_status",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "adset_name",
      "exp_in_market",
      "investments",
      "convertible",
      "clickid",
      "clicktype",
    ];

    fields.forEach((field) => {
      if (merged[field] !== undefined && merged[field] !== null && merged[field] !== "") {
        filterParams[field] = merged[field];
      }
    });

    const dateFields = [
      "created_on",
      "next_followup",
      "updated_on",
      "subscribed_on",
      "recent_contacted",
    ];

    dateFields.forEach((field) => {
      const start = merged[`${field}_start`];
      const end = merged[`${field}_end`];

      if (start) {
        filterParams[`s${field}`] = moment(start).format("YYYY-MM-DD");
      }
      if (end) {
        filterParams[`e${field}`] = moment(end).format("YYYY-MM-DD");
      }
      if (start && end) {
        filterParams[field] = `${moment(start).format("DD-MM-YYYY")} - ${moment(end).format("DD-MM-YYYY")}`;
      }
    });

    if (merged.first_amount) {
      const amountRange = parseAmountRange(merged.first_amount);
      if (amountRange.min !== undefined) filterParams.min_first_amount = amountRange.min;
      if (amountRange.max !== undefined) filterParams.max_first_amount = amountRange.max;
    }

    return filterParams;
  };

  // Fetch subscriber data
  const fetchSubscriberData = useCallback(
    async (pageNumber = 1) => {
      try {
        setLoading(true);
        setIsRendering(true);
        tableRenderedRef.current = false;

        const token = localStorage.getItem("authToken");

        const filterParams = buildFilterPayload(filters, {}, false);
        filterParams.page = pageNumber - 1; // Backend expects 0-based page

        console.log("API Payload:", filterParams);

        const response = await axios.post(
          `${API_URL}report/subscriber-analysis`,
          filterParams,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              accept: "*/*",
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data) {
          // Set subscriber data
          setSubscriberData(response.data.subscriber || []);

          // Set dropdown options from response
          const transformedDropdowns = transformDropdownData(response.data);
          setDropdownOptions(transformedDropdowns);

          // Set pagination
          const totalRecords =
            response.data.totalRecords || response.data.subscriber?.length || 0;
          const totalPages = Math.ceil(totalRecords / filters.limit);
          const startRecord = (pageNumber - 1) * filters.limit + 1;
          const endRecord = Math.min(pageNumber * filters.limit, totalRecords);

          setPagination({
            currentPage: pageNumber,
            totalPages: totalPages,
            totalRecords: totalRecords,
            showingRecords: `${startRecord} to ${endRecord} of ${totalRecords}`,
          });

          setTimeout(() => {
            tableRenderedRef.current = true;
            checkRenderingStatus();
          }, 100);
        }
      } catch (error) {
        console.error("Error fetching subscriber data:", error);
        console.error("Error details:", error.response?.data);
        setSubscriberData([]);
        tableRenderedRef.current = true;
        checkRenderingStatus();
        showToast.error("Failed to fetch subscriber data");
      } finally {
        setLoading(false);
      }
    },
    [filters]
  );

  const checkRenderingStatus = () => {
    if (tableRenderedRef.current) {
      setTimeout(() => {
        setIsRendering(false);
      }, 300);
    }
  };

  useEffect(() => {
    fetchSubscriberData(filters.page);
  }, [filters, fetchSubscriberData]);

  // Double scroll implementation
  useEffect(() => {
    const updateScrollbar = () => {
      if (tableContainerRef.current && topScrollbarContentRef.current) {
        const tableWidth = tableContainerRef.current.scrollWidth;
        topScrollbarContentRef.current.style.width = `${tableWidth}px`;
      }
    };

    updateScrollbar();
    window.addEventListener("resize", updateScrollbar);
    return () => window.removeEventListener("resize", updateScrollbar);
  }, [subscriberData]);

  const isSyncingScrollRef = useRef(false);
  const lastTableScrollLeftRef = useRef(0);

  const syncScroll = () => {
    if (tableContainerRef.current && topScrollbarRef.current) {
      const currentLeft = tableContainerRef.current.scrollLeft;
      if (currentLeft === lastTableScrollLeftRef.current) return;
      lastTableScrollLeftRef.current = currentLeft;
      if (isSyncingScrollRef.current) return;
      isSyncingScrollRef.current = true;
      topScrollbarRef.current.scrollLeft = currentLeft;
      requestAnimationFrame(() => {
        isSyncingScrollRef.current = false;
      });
    }
  };

  const handleTopScroll = () => {
    if (tableContainerRef.current && topScrollbarRef.current) {
      const currentLeft = topScrollbarRef.current.scrollLeft;
      if (isSyncingScrollRef.current) return;
      isSyncingScrollRef.current = true;
      tableContainerRef.current.scrollLeft = currentLeft;
      lastTableScrollLeftRef.current = currentLeft;
      requestAnimationFrame(() => {
        isSyncingScrollRef.current = false;
      });
    }
  };

  // Handle form input changes
  const handleFormInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



  // Handle date range changes for specific fields
  const handleDateChange = (field, dates) => {
    const [start, end] = dates;
    setFormInputs((prev) => ({
      ...prev,
      [`${field}_start`]: start,
      [`${field}_end`]: end,
    }));
  };

  // Apply specific date filter
  const applyDateFilter = (dateField) => {
    setFilters((prev) => ({
      ...prev,
      [`${dateField}_start`]: formInputs[`${dateField}_start`],
      [`${dateField}_end`]: formInputs[`${dateField}_end`],
      page: 1,
    }));
  };

  // Apply all filters
  const applyFilters = () => {
    setFilters((prev) => ({
      ...prev,
      recent_contacted_start: formInputs.recent_contacted_start,
      recent_contacted_end: formInputs.recent_contacted_end,
      created_on_start: formInputs.created_on_start,
      created_on_end: formInputs.created_on_end,
      lead_source: formInputs.lead_source,
      inv_capital: formInputs.inv_capital,
      lead_status: formInputs.lead_status,
      next_followup_start: formInputs.next_followup_start,
      next_followup_end: formInputs.next_followup_end,
      subscriberid: formInputs.subscriberid,
      language: formInputs.language,
      state: formInputs.state,
      client_status: formInputs.client_status,
      subscribed_on_start: formInputs.subscribed_on_start,
      subscribed_on_end: formInputs.subscribed_on_end,
      subscriber_status: formInputs.subscriber_status,
      updated_on_start: formInputs.updated_on_start,
      updated_on_end: formInputs.updated_on_end,
      utm_source: formInputs.utm_source,
      utm_medium: formInputs.utm_medium,
      utm_campaign: formInputs.utm_campaign,
      utm_content: formInputs.utm_content,
      utm_term: formInputs.utm_term,
      adset_name: formInputs.adset_name,
      exp_in_market: formInputs.exp_in_market,
      investments: formInputs.investments,
      convertible: formInputs.convertible,
      clickid: formInputs.clickid,
      clicktype: formInputs.clicktype,
      first_amount: formInputs.first_amount,
      page: 1,
    }));
  };

  // Handle Enter key in text inputs
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      applyFilters();
    }
  };

  const handleSort = (column) => {
    setFilters((prev) => ({
      ...prev,
      orderbycol: column,
      orderby:
        prev.orderbycol === column && prev.orderby === "asc" ? "desc" : "asc",
      page: 1,
    }));
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setFilters((prev) => ({ ...prev, page: newPage }));
    }
  };

  const exportReport = async () => {
    try {
      setExportLoading(true);
      const token = localStorage.getItem("authToken");

      const filterParams = buildFilterPayload(filters, formInputs, true);
      console.log("Export Payload:", filterParams);

      const response = await axios.post(
        `${API_URL}report/subscriber-analysis/export`,
        filterParams,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `subscriber-analysis-report-${new Date().toISOString().split("T")[0]
        }.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      showToast.success("Report exported successfully.");
    } catch (error) {
      console.error("Error exporting report:", error);
      showToast.error("Failed to export report. Please try again.");
    } finally {
      setExportLoading(false);
    }
  };

  const clearFilters = () => {
    setFormInputs({
      recent_contacted_start: null,
      recent_contacted_end: null,
      created_on_start: null,
      created_on_end: null,
      lead_source: "",
      inv_capital: "",
      lead_status: "",
      next_followup_start: null,
      next_followup_end: null,
      subscriberid: "",
      language: "",
      state: "",
      client_status: "",
      subscribed_on_start: null,
      subscribed_on_end: null,
      subscriber_status: "",
      updated_on_start: null,
      updated_on_end: null,
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      utm_content: "",
      utm_term: "",
      adset_name: "",
      exp_in_market: "",
      investments: "",
      convertible: "",
      clickid: "",
      clicktype: "",
      first_amount: "",
    });
    setFilters({
      recent_contacted_start: "",
      recent_contacted_end: "",
      created_on_start: "",
      created_on_end: "",
      lead_source: "",
      inv_capital: "",
      lead_status: "",
      next_followup_start: "",
      next_followup_end: "",
      subscriberid: "",
      language: "",
      state: "",
      client_status: "",
      subscribed_on_start: "",
      subscribed_on_end: "",
      subscriber_status: "",
      updated_on_start: "",
      updated_on_end: "",
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      utm_content: "",
      utm_term: "",
      adset_name: "",
      exp_in_market: "",
      investments: "",
      convertible: "",
      clickid: "",
      clicktype: "",
      first_amount: "",
      orderbycol: "created_on",
      orderby: "desc",
      page: 1,
      limit: 100,
    });
  };

  useEffect(() => {
    const handleClearFilters = () => {
      clearFilters();
    };
    window.addEventListener('clearSubscriberAnalysisReportFiltersEvent', handleClearFilters);
    return () => {
      window.removeEventListener('clearSubscriberAnalysisReportFiltersEvent', handleClearFilters);
    };
  }, []);

  // Helper functions
  const getSortIcon = (column) => {
    if (filters.orderbycol !== column) return faSort;
    return filters.orderby === "asc" ? faSortUp : faSortDown;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";
      return moment(date).format("DD-MM-YYYY HH:mm A");
    } catch (error) {
      return "";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "0000-00-00") return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";
      return moment(date).format("DD-MM-YYYY");
    } catch (error) {
      return "";
    }
  };

  const hasAnyFilter = () => {
    const filterKeys = Object.keys(filters);
    return filterKeys.some(
      (key) =>
        !["orderbycol", "orderby", "page", "limit"].includes(key) &&
        filters[key] &&
        filters[key] !== ""
    );
  };

  const handleRowClick = (subscriberId) => {
    window.open(`/subscriber/edit/${subscriberId}`, "_blank");
  };

  const isPrevDisabled = pagination.currentPage <= 1;
  const isNextDisabled = pagination.currentPage >= pagination.totalPages;

  return (
    <div className="panel-content mt-5">
      {/* {(loading || isRendering) && <LoadingSpinner />} */}

      {/* Header with Breadcrumb and Controls */}
      <div className="panel-heading d-flex justify-content-between">
        <div className="col-md-4">
          <div
            style={{ float: "left", position: "relative", marginLeft: "5px" }}
          >
            {hasAnyFilter() && (
              <button
                className="btn btn-default btn-xs ml-1"
                style={{ marginLeft: "6px" }}
                onClick={clearFilters}
                title="Clear all filters"
              >
                Clear Filter
              </button>
            )}
          </div>
        </div>
        <div>
          <span style={{ fontSize: "0.8rem" }} className="me-3">
            {loading ? (
              <span
                className="skeleton-text"
                style={{ width: "140px", display: "inline-block" }}
              ></span>
            ) : (
              pagination.showingRecords
            )}
          </span>
          <button
            className="btn btn-default btn-sm mx-1"
            onClick={() => fetchSubscriberData(1)}
          >
            <FontAwesomeIcon icon={faSync} />
          </button>
          <button
            className="btn btn-default btn-sm mx-1"
            onClick={exportReport}
            disabled={exportLoading || subscriberData.length === 0}
          >
            {exportLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Exporting...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faDownload} /> Export Report
              </>
            )}
          </button>

          <button
            className={`btn btn-default btn-sm ${isPrevDisabled ? "d-none" : ""
              }`}
            title="Previous"
            onClick={() => handlePageChange(filters.page - 1)}
            disabled={isPrevDisabled}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          &nbsp;
          <button
            className={`btn btn-default btn-sm ${isNextDisabled ? "d-none" : ""
              }`}
            title="Next"
            onClick={() => handlePageChange(filters.page + 1)}
            disabled={isNextDisabled}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>

      {/* Main Panel */}
      <div className="panel panel-default with-rounded-corner with-shadow p-10">
        <div className="large-table-container-3">
          {/* Top Scrollbar */}
          <div
            ref={topScrollbarRef}
            onScroll={handleTopScroll}
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              height: "16px",
              marginBottom: "2px",
              background: "#f8f9fa",
            }}
          >
            <div ref={topScrollbarContentRef} style={{ height: "1px" }}></div>
          </div>

          {/* Table Container */}
          <div
            ref={tableContainerRef}
            onScroll={syncScroll}
            style={{
              overflowY: "auto",
              height: "calc(112vh - 250px)",
              overflowX: "auto",
              position: "relative",
            }}
          >
            <table className="table table-condensed table-hover bg-white sticky-table">
              <thead>
                {/* Header Row */}
                <tr style={{ cursor: "pointer" }}>
                  <th
                    style={{ minWidth: "170px" }}
                    onClick={() => handleSort("recent_contacted")}
                  >
                    Recent Contacted{" "}
                    <FontAwesomeIcon icon={getSortIcon("recent_contacted")} />
                  </th>
                  <th
                    style={{ minWidth: "155px" }}
                    onClick={() => handleSort("created_on")}
                  >
                    Created Time{" "}
                    <FontAwesomeIcon icon={getSortIcon("created_on")} />
                  </th>
                  <th
                    style={{ width: "85px" }}
                    onClick={() => handleSort("lead_source")}
                  >
                    Lead Source{" "}
                    <FontAwesomeIcon icon={getSortIcon("lead_source")} />
                  </th>
                  <th
                    style={{ width: "80px" }}
                    onClick={() => handleSort("inv_capital")}
                  >
                    Inv. Capital{" "}
                    <FontAwesomeIcon icon={getSortIcon("inv_capital")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("lead_status")}
                  >
                    Lead Status{" "}
                    <FontAwesomeIcon icon={getSortIcon("lead_status")} />
                  </th>
                  <th
                    style={{ width: "100px" }}
                    onClick={() => handleSort("exp_in_market")}
                  >
                    Exp in Market{" "}
                    <FontAwesomeIcon icon={getSortIcon("exp_in_market")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("investments")}
                  >
                    Investments{" "}
                    <FontAwesomeIcon icon={getSortIcon("investments")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("convertible")}
                  >
                    Convertible{" "}
                    <FontAwesomeIcon icon={getSortIcon("convertible")} />
                  </th>
                  <th
                    style={{ minWidth: "160px" }}
                    onClick={() => handleSort("next_followup")}
                  >
                    Followup Date{" "}
                    <FontAwesomeIcon icon={getSortIcon("next_followup")} />
                  </th>
                  <th
                    style={{ minWidth: "105px" }}
                    onClick={() => handleSort("subscriberid")}
                  >
                    Subscriber ID{" "}
                    <FontAwesomeIcon icon={getSortIcon("subscriberid")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("language")}
                  >
                    Language <FontAwesomeIcon icon={getSortIcon("language")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("state")}
                  >
                    State <FontAwesomeIcon icon={getSortIcon("state")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("client_status")}
                  >
                    Client Status{" "}
                    <FontAwesomeIcon icon={getSortIcon("client_status")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("subscribed_on")}
                  >
                    Subscribed On{" "}
                    <FontAwesomeIcon icon={getSortIcon("subscribed_on")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("subscribed_days")}
                  >
                    Subscribed Days{" "}
                    <FontAwesomeIcon icon={getSortIcon("subscribed_days")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("active_days")}
                  >
                    Active Days{" "}
                    <FontAwesomeIcon icon={getSortIcon("active_days")} />
                  </th>
                  <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("first_amount")}
                  >
                    Subscription Amount{" "}
                    <FontAwesomeIcon
                      icon={getSortIcon("first_amount")}
                    />
                  </th>
                  {/* <th
                    style={{ width: "90px" }}
                    onClick={() => handleSort("subscriber_status")}
                  >
                    Status{" "}
                    <FontAwesomeIcon icon={getSortIcon("subscriber_status")} />
                  </th> */}
                  <th
                    style={{ minWidth: "170px" }}
                    onClick={() => handleSort("updated_on")}
                  >
                    Modified Time{" "}
                    <FontAwesomeIcon icon={getSortIcon("updated_on")} />
                  </th>
                  <th onClick={() => handleSort("utm_source")}>
                    UTM Source{" "}
                    <FontAwesomeIcon icon={getSortIcon("utm_source")} />
                  </th>
                  <th onClick={() => handleSort("utm_medium")}>
                    UTM Medium{" "}
                    <FontAwesomeIcon icon={getSortIcon("utm_medium")} />
                  </th>
                  <th onClick={() => handleSort("utm_campaign")}>
                    UTM Campaign{" "}
                    <FontAwesomeIcon icon={getSortIcon("utm_campaign")} />
                  </th>
                  <th onClick={() => handleSort("utm_content")}>
                    UTM Content{" "}
                    <FontAwesomeIcon icon={getSortIcon("utm_content")} />
                  </th>
                  <th onClick={() => handleSort("utm_term")}>
                    UTM Term <FontAwesomeIcon icon={getSortIcon("utm_term")} />
                  </th>
                  <th onClick={() => handleSort("adset_name")}>
                    Adset Name{" "}
                    <FontAwesomeIcon icon={getSortIcon("adset_name")} />
                  </th>
                  <th onClick={() => handleSort("clickid")}>
                    Click ID <FontAwesomeIcon icon={getSortIcon("clickid")} />
                  </th>
                  <th onClick={() => handleSort("clicktype")}>
                    Click Type <FontAwesomeIcon icon={getSortIcon("clicktype")} />
                  </th>
                </tr>

                {/* Filter Row */}
                <tr>
                  {/* Recent Contacted */}
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={formInputs.recent_contacted_start}
                        onChange={(dates) =>
                          handleDateChange("recent_contacted", dates)
                        }
                        startDate={formInputs.recent_contacted_start}
                        endDate={formInputs.recent_contacted_end}
                        selectsRange
                        isClearable
                        placeholderText=""
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        style={{ width: "110px" }}
                        toggleCalendarOnIconClick
                        monthsShown={3}
                        openToDate={
                          formInputs.recent_contacted_start || new Date()}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                        minDate={new Date(2018, 0, 1)}
                        maxDate={new Date(2030, 11, 31)}
                      />

                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => applyDateFilter("recent_contacted")}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>

                  {/* Created Time */}
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={formInputs.created_on_start}
                        onChange={(dates) =>
                          handleDateChange("created_on", dates)
                        }
                        startDate={formInputs.created_on_start}
                        endDate={formInputs.created_on_end}
                        selectsRange
                        isClearable
                        placeholderText=""
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        style={{ width: "110px" }}
                        toggleCalendarOnIconClick
                        monthsShown={3}
                        openToDate={
                          formInputs.created_on_start || new Date()}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                        minDate={new Date(2018, 0, 1)}
                        maxDate={new Date(2030, 11, 31)}
                      />
                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => applyDateFilter("created_on")}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>

                  {/* Lead Source */}
                  <th>
                    <div style={{ width: "130px" }}>
                      <Select
                        name="lead_source"
                        value={
                          dropdownOptions.leadSourceList.find(
                            (opt) => opt.value === formInputs.lead_source
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.leadSourceList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Inv. Capital */}
                  <th>
                    <div style={{ width: "130px" }}>
                      <Select
                        name="inv_capital"
                        value={
                          dropdownOptions.invCapitalList.find(
                            (opt) => opt.value === formInputs.inv_capital
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.invCapitalList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Lead Status */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="lead_status"
                        value={
                          dropdownOptions.leadStatusList.find(
                            (opt) => opt.value === formInputs.lead_status
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.leadStatusList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Exp in Market */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="exp_in_market"
                        value={
                          dropdownOptions.expInMarketList.find(
                            (opt) => opt.value === formInputs.exp_in_market
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.expInMarketList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Investments */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="investments"
                        value={
                          dropdownOptions.investmentsList.find(
                            (opt) => opt.value === formInputs.investments
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.investmentsList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Convertible */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="convertible"
                        value={
                          dropdownOptions.convertibleList.find(
                            (opt) => opt.value === formInputs.convertible
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.convertibleList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Followup Date */}
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={formInputs.next_followup_start}
                        onChange={(dates) =>
                          handleDateChange("next_followup", dates)
                        }
                        startDate={formInputs.next_followup_start}
                        endDate={formInputs.next_followup_end}
                        selectsRange
                        isClearable
                        placeholderText=""
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        style={{ width: "110px" }}
                        toggleCalendarOnIconClick
                        monthsShown={3}
                        openToDate={
                          formInputs.next_followup_start || new Date()}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                        minDate={new Date(2018, 0, 1)}
                        maxDate={new Date(2030, 11, 31)}
                      />

                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => applyDateFilter("next_followup")}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>

                  {/* Subscriber ID */}
                  <th>
                    <input
                      type="text"
                      name="subscriberid"
                      placeholder="ID"
                      value={formInputs.subscriberid}
                      onChange={handleFormInputChange}
                      onKeyDown={handleKeyDown}
                      style={{
                        width: "60px",
                        padding: "5px",
                        marginRight: "5px",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-default btn-xs btn-group-xs"
                      onClick={applyFilters}
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  </th>

                  {/* Language */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="language"
                        value={
                          dropdownOptions.languageList.find(
                            (opt) => opt.value === formInputs.language
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.languageList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* State */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="state"
                        value={
                          dropdownOptions.stateList.find(
                            (opt) => opt.value === formInputs.state
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.stateList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Client Status */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="client_status"
                        value={
                          dropdownOptions.clientStatusList.find(
                            (opt) => opt.value === formInputs.client_status
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.clientStatusList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Subscribed On */}
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={formInputs.subscribed_on_start}
                        onChange={(dates) =>
                          handleDateChange("subscribed_on", dates)
                        }
                        startDate={formInputs.subscribed_on_start}
                        endDate={formInputs.subscribed_on_end}
                        selectsRange
                        isClearable
                        placeholderText=""
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        style={{ width: "110px" }}
                        toggleCalendarOnIconClick
                        monthsShown={3}
                        openToDate={
                          formInputs.subscribed_on_start || new Date()}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                        minDate={new Date(2018, 0, 1)}
                        maxDate={new Date(2030, 11, 31)}
                      />

                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => applyDateFilter("subscribed_on")}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>

                  {/* Subscribed Days - No filter */}
                  <th></th>

                  {/* Active Days - No filter */}
                  <th></th>

                  {/* Subscription Amount */}
                  <th>
                    <input
                      type="text"
                      name="first_amount"
                      placeholder="1000 - 2000"
                      value={formInputs.first_amount}
                      onChange={handleFormInputChange}
                      onKeyDown={handleKeyDown}
                      style={{ width: "75px", padding: "5px" }}
                    />
                    <button
                      type="button"
                      className="btn btn-default btn-xs btn-group-xs"
                      onClick={applyFilters}
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  </th>

                  {/* Status */}
                  {/* <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="subscriber_status"
                        value={
                          dropdownOptions.subscriberStatusList.find(
                            (opt) => opt.value === formInputs.subscriber_status
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.subscriberStatusList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th> */}

                  {/* Modified Time */}
                  <th>
                    <div className="d-flex align-items-center gap-1">
                      <DatePicker
                        selected={formInputs.updated_on_start}
                        onChange={(dates) =>
                          handleDateChange("updated_on", dates)
                        }
                        startDate={formInputs.updated_on_start}
                        endDate={formInputs.updated_on_end}
                        selectsRange
                        isClearable
                        placeholderText=""
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        style={{ width: "110px" }}
                        toggleCalendarOnIconClick
                        monthsShown={3}
                        openToDate={
                          formInputs.updated_on_start || new Date()}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                        minDate={new Date(2018, 0, 1)}
                        maxDate={new Date(2030, 11, 31)}
                      />

                      <button
                        type="button"
                        className="btn btn-default btn-xs btn-group-xs"
                        onClick={() => applyDateFilter("updated_on")}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </th>

                  {/* UTM Source */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="utm_source"
                        value={
                          dropdownOptions.utmSourceList.find(
                            (opt) => opt.value === formInputs.utm_source
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.utmSourceList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* UTM Medium */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="utm_medium"
                        value={
                          dropdownOptions.utmMediumList.find(
                            (opt) => opt.value === formInputs.utm_medium
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.utmMediumList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* UTM Campaign */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="utm_campaign"
                        value={
                          dropdownOptions.utmCampaignList.find(
                            (opt) => opt.value === formInputs.utm_campaign
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.utmCampaignList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* UTM Content */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="utm_content"
                        value={
                          dropdownOptions.utmContentList.find(
                            (opt) => opt.value === formInputs.utm_content
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.utmContentList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* UTM Term */}
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="utm_term"
                        value={
                          dropdownOptions.utmTermList.find(
                            (opt) => opt.value === formInputs.utm_term
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.utmTermList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>

                  {/* Adset Name */}
                  <th>
                    <div style={{ width: "200px" }}>
                      <Select
                        name="adset_name"
                        value={
                          dropdownOptions.adsetNameList.find(
                            (opt) => opt.value === formInputs.adset_name
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.adsetNameList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>
                  <th>
                    <input
                      type="text"
                      name="clickid"
                      placeholder="Click ID"
                      value={formInputs.clickid}
                      onChange={handleFormInputChange}
                      onKeyDown={handleKeyDown}
                      style={{
                        width: "150px",
                        padding: "5px",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-default btn-xs btn-group-xs"
                      onClick={applyFilters}
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  </th>
                  <th>
                    <div style={{ width: "150px" }}>
                      <Select
                        name="clicktype"
                        value={
                          dropdownOptions.clickTypeList.find(
                            (opt) => opt.value === formInputs.clicktype
                          ) || null
                        }
                        onChange={handleReactSelectChange}
                        options={dropdownOptions.clickTypeList}
                        styles={customSelectStyles}
                        isSearchable
                        isClearable
                        placeholder="--select--"
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {(loading || isRendering) ? (
                  // Skeleton loading rows (initial load + filter apply)
                  Array.from({ length: 10 }).map((_, skeletonIndex) => (
                    <tr key={`skeleton-${skeletonIndex}`} className="skeleton-row">
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "50%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "65%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "55%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "65%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "40%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "40%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "50%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "55%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "65%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "65%" }}></div></td>
                      <td><div className="skeleton-text" style={{ width: "65%" }}></div></td>
                    </tr>
                  ))
                ) : subscriberData.length > 0 ? (
                  subscriberData.map((item, idx) => (
                    <tr
                      key={idx}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleRowClick(item.id)}
                    >
                      <td>{formatDateTime(item.recent_contacted)}</td>
                      <td>{formatDateTime(item.created_on)}</td>
                      <td>{item.lead_source}</td>
                      <td>{item.inv_capital}</td>
                      <td>{item.lead_status}</td>
                      <td>{item.exp_in_market}</td>
                      <td>{item.investments}</td>
                      <td>{item.convertible}</td>
                      <td>{formatDate(item.next_followup)}</td>
                      <td>{item.subscriberid}</td>
                      <td>{item.language_name || item.languagename || ""}</td>
                      <td>{item.state_name || item.state || ""}</td>
                      <td>{item.client_status}</td>
                      <td>{formatDate(item.subscribed_on)}</td>
                      <td style={{ textAlign: "right" }}>
                        {item.subscribed_days > 0 ? item.subscribed_days : ""}
                      </td>
                      <td>{item.active_days > 0 ? item.active_days : ""}</td>
                      <td>
                        {item.first_amount > 0
                          ? item.first_amount
                          : ""}
                      </td>
                      {/* <td>{item.subscriber_status}</td> */}
                      <td>{formatDateTime(item.updated_on)}</td>
                      <td>{item.utm_source}</td>
                      <td>{item.utm_medium}</td>
                      <td>{item.utm_campaign}</td>
                      <td>{item.utm_content}</td>
                      <td>{item.utm_term}</td>
                      <td>{item.adset_name}</td>
                      <td
                        style={{
                          maxWidth: "150px",
                          minWidth: "150px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          cursor: "default"
                        }}
                        title={item.clickid || ""}
                      >
                        {item.clickid}
                      </td>
                      <td>{dropdownOptions.clickTypeList.find(opt => opt.value == item.clicktype)?.label || item.clicktype}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="26" className="text-center py-4">
                      No subscriber records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style jsx>{`
        .breadcrumb {
          background: transparent;
          margin-bottom: 0;
          padding: 0;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          content: ">";
        }

        .panel {
          background: white;
          border-radius: 4px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .with-rounded-corner {
          border-radius: 4px;
        }

        .with-shadow {
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .table-condensed th,
        .table-condensed td {
          padding: 8px 5px;
          font-size: 12px;
        }

        .btn-default {
          background: #f8f9fa;
          border: 1px solid #ddd;
        }

        .btn-xs {
          padding: 1px 5px;
          font-size: 12px;
          line-height: 1.5;
        }

        .form-control.input-sm {
          height: 28px;
          padding: 3px 6px;
          font-size: 12px;
        }

        th {
          white-space: nowrap;
          background: #f8f9fa;
        }

        .table-hover tbody tr:hover {
          background-color: #f5f5f5;
        }

        select {
          padding: 3px 5px;
        }
        .react-datepicker {
          margin-left: 150px;
        }
      `}</style>
    </div>
  );
};

export default SubscriberAnalysisReport;